import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import WorkspaceListItem from './workspace-list-item.jsx';
import styles from './workspace-list.module.scss';

export default function WorkspaceList({ workspaces, onDelete, loading, deletingWorkspaceIDs}) {
  const showLoadingIndicator = loading && workspaces.length === 0;

  if (showLoadingIndicator) {
    return (
      <div className={styles.loadingIndicator} data-testid="loading-indicator">
        <FontAwesomeIcon icon={faCircleNotch} spin size="2x" color="#6B7280" />
      </div>
    );
  }

  return (
    <div className={styles.workspaceList}>
      {workspaces.map(ws => (
        <WorkspaceListItem
          key={ws.id}
          workspace={ws}
          onDelete={() => onDelete(ws)}
          isDeleting={deletingWorkspaceIDs.includes(ws.id)}
        />
      ))}
    </div>
  );
}
